import { render, staticRenderFns } from "./site-trending.vue?vue&type=template&id=5073e504&scoped=true"
import script from "./site-trending.vue?vue&type=script&lang=ts"
export * from "./site-trending.vue?vue&type=script&lang=ts"
import style0 from "./site-trending.vue?vue&type=style&index=0&id=5073e504&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073e504",
  null
  
)

export default component.exports